/**
 * 데스크톱용 공지사항 목록 페이지
 * API에서 공지사항 데이터를 가져와 목록으로 표시합니다.
 */

import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import SubPage from '../template/SubPage';
import ItemList from '../components/ItemList';
import useAsync from '../hooks/useAsync';
import { getNotices } from '../Api';
import { Sort } from '../utils/Sort';
import { MENU_DATA } from '../constant/menuData';
import MyHelmet from '../hooks/Helmet';

// 한 페이지에 표시할 공지사항 개수
const LIMIT = 6;

function NoticePage() {
  const [order] = useState('createdAt');
  const [, loadingError, getNoticessAsync] = useAsync(getNotices);
  const [items, setItems] = useState([]);

  // ID 기준 내림차순 정렬 후 Sort 유틸리티로 추가 처리
  const sortedItems = Sort(items.sort((a, b) => b['id'] - a['id']));

  // 메뉴 데이터 가져오기
  const menuData = MENU_DATA.community;

  /**
   * 공지사항 데이터를 로드하는 핸들러
   */
  const handleLoad = useCallback(
    async (options) => {
      const result = await getNoticessAsync(options);
      if (!result) return;

      const datas = result;
      if (options.offset === 0) {
        setItems(datas);
      } else {
        setItems((prevItems) => [...prevItems, ...datas]);
      }
    },
    [getNoticessAsync]
  );

  useEffect(() => {
    handleLoad({ order, offset: 0, limit: LIMIT });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MyHelmet />
      <SubPage
        title={menuData.label}
        description={menuData.description}
        menuItems={menuData.subMenus}
        currentNo="notice"
        submenuTitle="공지사항"
        breadcrumbMenu={menuData.label}
        breadcrumbLink={menuData.path}
    >
      <ItemList items={sortedItems} order="/notice/" />
      {loadingError?.message && (
        <ErrorMessage>{loadingError.message}</ErrorMessage>
      )}
    </SubPage>
    </>
  );
}

export default NoticePage;

/* Styled Components */

const ErrorMessage = styled.span`
  color: #e74c3c;
  font-size: 14px;
  display: block;
  margin-top: 20px;
`;
